import React from "react";
import DynamicTable2 from "../../components/DynamicTable2";
import {CheckboxInput, RadioButtonInput } from '../../components/FormInitiators';


const ArrearsSenventhForm4 = ({ formData, setFormData, onFormDataChange, onBack, onNext }) => {
 

    const handleInputChange = ({ target: { name, value } }) => {
        onFormDataChange({ [name]: value });
      };

    const onTableDataChange = (key) => (rows) => {
        setFormData((prevState) => {
          return { ...prevState, [key]: rows };
        });
      };

    return (
        <div className="google_forms">
        <div className="forms">

        <form className="seventh-pay-arrears-form">
            <div >
                <label>Sixth Pay Due Drawn Salary for the period 01-01-2016 to 31-12-2018</label>


            <label>
            <CheckboxInput
                value={formData.isArrearsBeforeDate}
                onChange={handleInputChange}
                name="isArrearsBeforeDate"
                label="Are the Arrears to be calculated before 31-12-2018?:"
            />
            </label>
            

            {formData.isArrearsBeforeDate && (
                <>
                <label>
                    Due Pay Band: (sixth pay)
                    <select name="duePaybandSixthPay" value={formData.duePaybandSixthPay || ""} onChange={handleInputChange}>
                        <option value="S-1">-S1 : 4440-7440</option>
                        <option value="PB-1">PB-1 : 5200-20200</option>
                        <option value="PB-2">PB-2 : 9300-34800</option>
                        <option value="PB-3">PB-3 : 15600-39100</option>
                        <option value="PB-4">PB-4 : 37400-67100</option>
                    </select>
                </label>

                 <label>
                        <RadioButtonInput
                          value={formData.newAppointment} 
                          onChange={handleInputChange}
                          name="newAppointment"  
                          orientation="horizontal"  
                          options={[
                            { value: 'true', label: 'New Appointment' },
                            { value: 'false', label: 'Placement' }
                          ]}    
                        />
                      </label>

                {/* Due Salary Details Table */}
                <DynamicTable2
                    tableName="Due Salary Details (sixth pay)"
                    columns={[
                    { header: "Date", key: "date", type: "date", disableFirstRow: true },
                    { header: "Pay In Pay Band",name: "payInPayBand", key: "payInPayBand", type: "number" },
                    {header: "AGP", key: "AGP", type: "number"}
                    ]}
                    localStorageKey="dueSalaryDetailsSixthPay"
                    onTableDataChange={onTableDataChange("dueSalaryDetailsSixthPay")}
 
                />

                {/* Drawn Salary Details Table */}
                <DynamicTable2
                    tableName="Drawn Salary Details (sixth pay)"
                    columns={[
                    { header: "Date", key: "date", type: "date", disableFirstRow: true },
                    { header: "Pay In Pay Band",name: "payInPayBand", key: "payInPayBand", type: "number" },
                    {header: "AGP", key: "AGP", type: "number"}
                    ]}
                    localStorageKey="drawnSalaryDetailsSixthPay"
                    onTableDataChange={onTableDataChange("drawnSalaryDetailsSixthPay")}

                />
                 
            </>
                )}
        {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>
          Back
        </button>
        <button type="button" onClick={onNext}>
         Next
        </button>
        </div>
        </div>
    </form>
        </div>
        </div>
    );
};

export default ArrearsSenventhForm4;